<template>
    <v-card color="primary"
        :disabled="['entrega-material-lupi-pesquisa-item', 'list-produtos'].includes($store.state.lupi.loading_id)">
        <v-card-title class="text-overline">
            {{ form.codigo_item_lupi }}
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-icon class="mr-2">mdi-check-decagram</v-icon>
                {{ form.descricao_item_lupi }}
            </v-row>
            <v-row>
                <v-col cols="12" sm="4" md="3">
                    <!-- eslint-disable-next-line -->
                    <v-text-field v-model="form.quantidade_entregue" type="number" step="1" label="Entregando"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="3">
                    <!-- eslint-disable-next-line -->
                    <v-text-field v-model="form.quantidade_entregar" type="number" step="1" label="Entregar"></v-text-field>
                </v-col>
                <v-col cols="12" sm="4" md="3">
                    <v-btn :loading="$store.state.checklistdb.loading_id === 'registra-entrega-material-lupi'"
                        color="success" @click="registrarEntregaMaterial(form)">
                        <v-icon class="mr-2">mdi-check</v-icon> Registrar
                    </v-btn>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    props: {
        form: {
            required: true
        }  
    },
    methods: {
        registrarEntregaMaterial() {
            const form = Object.assign({}, this.form)
            this.$emit('on-registrar-entrega-material', form)
        }
    }
}
</script>